module.exports = __webpack_public_path__ + "static/img/tx.b8c2809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tx.png
// module id = +RyT
// module chunks = 128